module.exports = __webpack_public_path__ + "static/img/GY.1f021610.png";